import React from "react";
import "../../../styles/About/Route/Intro.scss";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const Intro = ({ darkTheme }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigate to the previous page
  };
  return (
    <>
      <div className={`about-intro ${darkTheme ? "dark" : "light"}`}>
        <div className="about-intro__container">
          <div className="about-intro__header">
            <h2 className="about-intro__number">
              0<span>1</span>
            </h2>
            <h1
              data-aos="fade-down"
              data-aos-offset="0"
              style={{
                color: darkTheme ? "white" : "transparent",
                background: darkTheme
                  ? "none"
                  : "linear-gradient(167deg, #79a6d2 21%, #ffb3e6)",
                WebkitBackgroundClip: darkTheme ? "none" : "text",
                WebkitTextFillColor: darkTheme ? "white" : "transparent",
              }}
            >
              H<span>ello</span>.
            </h1>
            <button
              className="experience__close-button"
              onClick={handleGoBack}
              style={{
                background: "none",
                border: "none",
                color: darkTheme ? "white" : "black",
                cursor: "pointer",
                position: "absolute",
                top: "2px",
                right: "20px",
                padding: "10px", // Increase padding for better clickability
              }}
            >
              <FontAwesomeIcon icon={faTimes} size="xl" />
            </button>
          </div>
          <div
            className="about-intro__description"
            style={{
              color: darkTheme ? "white" : "black",
              fontWeight: darkTheme ? "none" : 500,
            }}
          >
            <p data-aos="fade-right">
              I am <span>Mohd Aquib....</span>
            </p>
            <p data-aos="fade-right" data-aos-delay="200">
              {" "}
              I am proficient in Python, C++, SQL, and MongoDB, I specialize in
              data analysis and manipulation, leveraging Docker for seamless
              deployment.
            </p>
            <p data-aos="fade-right" data-aos-delay="400">
              Experienced in deep learning frameworks like TensorFlow and
              PyTorch, I've developed advanced models including CNNs, RNNs, and
              GANs for tasks like object detection and image processing.
            </p>
            <p data-aos="fade-right" data-aos-delay="600">
              Skilled in data visualization with NumPy, Pandas, Matplotlib, and
              Seaborn, I craft insightful visualizations and extract actionable
              insights.
            </p>
            <p data-aos="fade-right" data-aos-delay="800">
              With a commitment to innovation, I collaborate effectively using
              Git and GitHub, delivering impactful solutions and driving
              business growth through machine learning and AI.{" "}
            </p>

            <div
              className="about-intro__emoji"
              style={{
                color: darkTheme ? "white" : "transparent",
                background: darkTheme
                  ? "none"
                  : "linear-gradient(167deg, #79a6d2 21%, #ffb3e6)",
                WebkitBackgroundClip: darkTheme ? "none" : "text",
                WebkitTextFillColor: darkTheme ? "white" : "transparent",
              }}
            >
              :&nbsp;)
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Intro;
